export default "__VITE_ASSET__4b9711d7__"